import CustomTable from "../table/CustomTable";
import CustomAccordion from "../accordion/CustomAccordion";
import List from "../list/List";
import { Tabs, Tab } from "react-bootstrap";

const TableTab = ({ data, children }) => {
  return (
    <Tabs defaultActiveKey={data.buttonlabel1} id="tab" className="mb-3">
      <Tab eventKey={data.buttonlabel1} title={data.buttonlabel1}>
        <CustomTable headers={data.headers1} rows={data.rows1} />
        <List data={data?.listItems1} desc={data?.listItems1Desc} />
      </Tab>
      <Tab eventKey={data.buttonlabel2} title={data.buttonlabel2}>
        <CustomTable headers={data.headers2} rows={data.rows2} />
        <List data={data?.listItems2} desc={data?.listItems2Desc} />
      </Tab>
      <Tab eventKey={data.buttonlabel3} title={data.buttonlabel3}>
        <CustomAccordion data={{ title: "Sözleşme ve Gerekli Belgeler" }}>
          {children}
        </CustomAccordion>
      </Tab>
    </Tabs>
  );
};

export default TableTab;
